import type React from 'react';

import Style from './AnalyticsTooltip.module.css';

interface IAnalyticsTooltip {
    title: string;
    data: { color: string; value: string; name: string }[];
}

export const AnalyticsTooltip: React.FC<IAnalyticsTooltip> = (props) => {
    const { title, data } = props;

    return (
        <div className={Style.analyticsTooltip}>
            <div className={Style.analyticsTooltipTitle}>{title}</div>
            {data.map((d) => (
                <div className={Style.analyticsTooltipValue} key={d.name}>
                    <div className={Style.analyticsTooltipValueColor} style={{ background: d.color }} />
                    <div className={Style.analyticsTooltipValueName}>{d.name}</div>
                    <div className={Style.analyticsTooltipValueData}>{d.value}</div>
                </div>
            ))}
        </div>
    );
};

AnalyticsTooltip.displayName = 'AnalyticsTooltip';
